import { render, staticRenderFns } from "./_SupplierDatabaseTable.vue?vue&type=template&id=471dcd6f"
import script from "./_SupplierDatabaseTable.vue?vue&type=script&lang=js"
export * from "./_SupplierDatabaseTable.vue?vue&type=script&lang=js"
import style0 from "./_SupplierDatabaseTable.vue?vue&type=style&index=0&id=471dcd6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports